module.exports = __webpack_public_path__ + "static/media/gallery-1.639d1c8c.png";